import { brokersService } from '@/services';
import { useQuery } from '@tanstack/react-query';

export type AdvisoryBrokersListParams = {
  filter?: string;
  pageSize?: number;
  pageNumber?: number;
};

export function useAdvisoryBrokers(
  advisoryId: string,
  params: AdvisoryBrokersListParams = {}
) {
  return useQuery({
    queryKey: ['advisory-brokers', advisoryId, params],
    queryFn: async () => {
      const response = await brokersService.listBrokers({
        page: params.pageNumber ?? 1,
        pageSize: params.pageSize ?? 10,
        search: params.filter ?? '',
        advisoryId,
      });
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar grade de corretores'
        );
      }
      return response.data;
    },
    enabled: Boolean(advisoryId),
    staleTime: 1000 * 60 * 5,
  });
}
